/**
 * Returns the path portion of a platform URL (same origin as the current page),
 * or null if the href belongs to a different origin or is already a path.
 * Use the returned path as an Angular router link (rtLink) rather than a full URL.
 */
export function toPlatformPath(href: string): string | null {
  const origin = window.location.origin;
  return href.startsWith(`${origin}/`) ? href.slice(origin.length) : null;
}

export function toMarkdownTable(columns: string[], rows: string[][]): string {
  const headerRow = `| ${columns.join(' | ')} |`;
  const separatorRow = `| ${columns.map(() => '---').join(' | ')} |`;
  const dataRows = rows.map((cells: string[]) => `| ${cells.join(' | ')} |`);

  return [headerRow, separatorRow, ...dataRows].join('\n');
}
